// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    CATEGORY_SCROLLING_MODULE_LOADING() {
      return {
        isLoading: true,
        categoryScrollingModule: action.categoryScrollingModule
      };
    },
    CATEGORY_SCROLLING_MODULE_LOADED() {
      return {
        isLoading: false,
        data: action.categoryScrollingModule
      };
    },
    CATEGORY_SCROLLING_MODULE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.categoryScrollingModule.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
